import type { ReactNode } from "react"
import { EmberServiceContext } from "./ember-service-context"

interface Props {
  /** The react-render modifier instance, whose Ember owner is used to look up services. */
  modifier: object
  children: ReactNode
}

export function EmberServiceProvider({ modifier, children }: Props) {
  return <EmberServiceContext.Provider value={modifier}>{children}</EmberServiceContext.Provider>
}
